import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { DistributorService, GetDistributorsResponse } from 'src/app/core/proto';
import { actionDistributorNamesListGet, actionDistributorNamesListGetFailure, actionDistributorNamesListGetSuccess } from 'src/app/core/store/distributors/distributors.actions';

@Injectable({
  providedIn: 'root',
})
export class DistributorsEffects {
  constructor(
    private distributorService: DistributorService,
    private actions$: Actions,
  ) { }

  /**
   * Get the list of distributor names
   */
  getDistributorNamesList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionDistributorNamesListGet),
      exhaustMap(params => {
        return this.distributorService
          .getDistributorsPublic(params.body)
          .pipe(
            map((res: GetDistributorsResponse) => {
              return actionDistributorNamesListGetSuccess({
                payload: res
              });
            },
            catchError(() => of(actionDistributorNamesListGetFailure()))
          ));
      })
    );
  });
}
